
import { Component, Vue } from 'vue-property-decorator';
import { OrderSuggestion } from '@/types/ApiInterfaces';

@Component
export default class OrderStepsBar extends Vue {
  minimized = false;

  get action(): string {
    return this.$store.getters['order/suggestionAction'];
  }

  get suggestion(): OrderSuggestion {
    return this.$store.state.order.suggestion;
  }

  get quantity(): number {
    const quantity = this.suggestion.CorrectionSuggestion
      ? this.suggestion.CorrectionSuggestion.NumPallets || 0
      : 0;
    return Math.abs(quantity);
  }

  get exceededWeight(): number {
    const exceededWeight = this.suggestion.ExceededWeight
      ? this.suggestion.ExceededWeight || 0
      : 0;
    return exceededWeight;
  }

  get showSuggestion(): boolean {
    return (
      this.action !== 'next-step' &&
      !this.$store.state.order.suggestionAccepted &&
      !this.$store.state.order.suggestionCancelled
    );
  }
}
